import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { orderActions } from 'redux/actionCreators'
import classes from './AdminOrder.scss'

// Components
import { Heading, Pagination, RadioButtonGroup, Searchbox } from 'components'
import DatePicker from 'react-datepicker'

// Helpers
import moment from 'moment'
import _get from 'lodash.get'
import _isEqual from 'lodash.isequal'
import { query, pageFromProps, formatMoney } from 'helpers/utilities'
import api from 'helpers/api'

const SEARCH_BY_OPTIONS = [
  { title: 'รายการตามสถานะสั่งซื้อ', value: 'status' },
  { title: 'ตามเงื่อนไข', value: 'keyword' },
  { title: 'ค้นหาทุกรายการ', value: 'time' }
]

const DELIVERY_STATUS = [
  { title: 'รอเช็คสินค้า', value: 'checking' },
  { title: 'กำลังดำเนินการ', value: 'packaging' },
  { title: 'ส่งสินค้าแล้ว', value: 'delivered' },
  { title: 'ยกเลิก', value: 'canceled' }
]
const PAID_STATUS = [
  { title: 'รอชำระเงิน', value: 'pending' },
  { title: 'เครดิตลูกหนี้', value: 'credit' },
  { title: 'ชำระเงินแล้ว', value: 'paid' }
]

const ORDER_STATUS_OPTIONS = [
  { title: 'รอเช็คสินค้า', value: 'checking' },
  { title: 'รอชำระเงิน', value: 'pending' },
  { title: 'เครดิตลูกหนี้', value: 'credit' },
  { title: 'ชำระเงินแล้ว', value: 'paid' },
  { title: 'ส่งสินค้าแล้ว', value: 'delivered' },
  { title: 'ยกเลิก', value: 'canceled' }
]

const mapStateToProps = (state) => ({
  orders: _get(state, ['order', 'orders']) || [],
  pageCount: _get(state, ['order', 'pageCount']) || 0,
  cwOrderCreating: _get(state, ['order', 'createCwOrderAttempting'])
})
const mapDispatchToProps = (dispatch) => ({
  attemptFindAllOrders: (payload) =>
    dispatch(orderActions.attemptFindAllOrders(payload)),
  attemptSaveOrder: (payload) =>
    dispatch(orderActions.attemptSaveOrder(payload)),
  attemptUploadInvoice: (payload) =>
    dispatch(orderActions.attemptUploadInvoice(payload)),
  attemptCreatePackPdf: (payload) =>
    dispatch(orderActions.attemptCreatePackPdf(payload)),
  attemptCreateCwOrder: (payload) =>
    dispatch(orderActions.attemptCreateCwOrder(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminOrders extends Component {
  static propTypes = {
    orders: PropTypes.array.isRequired,
    pageCount: PropTypes.number.isRequired,
    attemptFindAllOrders: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props)
    this.state = {
      startDate: query(props, 'startDate') ? moment(query(props, 'startDate'), 'YYYY-MM-DD') : undefined,
      endDate: query(props, 'endDate') ? moment(query(props, 'endDate'), 'YYYY-MM-DD') : undefined,
      createPackPdf: query(props, 'createPackPdf'),
      initialOrderPaidStatuses: props.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.paidStatus }), {}),
      orderPaidStatuses: props.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.paidStatus }), {}),
      initialOrderDeliveryStatuses: props.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.deliveryStatus }), {}),
      orderDeliveryStatuses: props.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.deliveryStatus }), {}),
      orderEditedPaidStates: props.orders.reduce((states, order) => ({ ...states, [order.orderId]: false }), {}),
      orderEditedDeliveryStates: props.orders.reduce((states, order) => ({ ...states, [order.orderId]: false }), {})
    }
  }

  componentWillMount() {
    this.props.attemptFindAllOrders({
      status: query(this.props, 'status') === 'all' ? '' : query(this.props, 'status'),
      keyword: query(this.props, 'keyword'),
      startDate: query(this.props, 'startDate'),
      endDate: query(this.props, 'endDate')
    })
  }

  componentWillReceiveProps(nextProps) {
    if (!_isEqual(_get(this.props, ['location', 'query']), _get(nextProps, ['location', 'query']))) {
      nextProps.attemptFindAllOrders({
        status: query(nextProps, 'status') === 'all' ? '' : query(nextProps, 'status'),
        keyword: query(nextProps, 'keyword'),
        startDate: query(nextProps, 'startDate'),
        endDate: query(nextProps, 'endDate'),
        offset: (pageFromProps(nextProps) - 1) * 10
      })
      this.setState({
        startDate: query(nextProps, 'startDate') ? moment(query(nextProps, 'startDate'), 'YYYY-MM-DD') : undefined,
        endDate: query(nextProps, 'endDate') ? moment(query(nextProps, 'endDate'), 'YYYY-MM-DD') : undefined
      })
    } else if (!_isEqual(this.props.orders, nextProps.orders)) {
      this.setState({
        initialOrderPaidStatuses: nextProps.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.paidStatus }), {}),
        orderPaidStatuses: nextProps.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.paidStatus }), {}),
        initialOrderDeliveryStatuses: nextProps.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.deliveryStatus }), {}),
        orderDeliveryStatuses: nextProps.orders.reduce((statuses, order) => ({ ...statuses, [order.orderId]: order.deliveryStatus }), {}),
        orderEditedPaidStates: nextProps.orders.reduce((states, order) => ({ ...states, [order.orderId]: false }), {}),
        orderEditedDeliveryStates: nextProps.orders.reduce((states, order) => ({ ...states, [order.orderId]: false }), {}),
        ...nextProps.orders.reduce((ordersVisible, order) => ({ ...ordersVisible, [`${order.orderId}Visible`]: false }), {})
      })
    }
  }

  _onSearchByChange = (searchBy) => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=${searchBy}`)
  }

  _onStatusChange = (status) => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=status&status=${status}`)
  }

  _onEditStatus = (orderId, statusType) => {
    if (statusType === 'paid') {
      this.setState({ orderEditedPaidStates: this.state.orderEditedPaidStates.merge({ [orderId]: true }) })
    } else if (statusType === 'delivery') {
      this.setState({ orderEditedDeliveryStates: this.state.orderEditedDeliveryStates.merge({ [orderId]: true }) })
    }
  }

  _onSaveStatus = (orderId, statusType) => {
    if (statusType === 'paid') {
      this.props.attemptSaveOrder({
        orderId,
        status: '',
        paidStatus: this.state.orderPaidStatuses[orderId]
      })
      this.setState({
        orderEditedPaidStates: this.state.orderEditedPaidStates.merge({ [orderId]: false })
      })
    } else if (statusType === 'delivery') {
      this.props.attemptSaveOrder({
        orderId,
        status: '',
        deliveryStatus: this.state.orderDeliveryStatuses[orderId]
      })
      this.setState({
        orderEditedDeliveryStates: this.state.orderEditedDeliveryStates.merge({ [orderId]: false })
      })
    }
  }

  _onCancelStatus = (orderId, statusType) => {
    if (statusType === 'paid') {
      this.setState({
        orderPaidStatuses: this.state.orderPaidStatuses.merge({ [orderId]: this.state.initialOrderPaidStatuses[orderId] }),
        orderEditedPaidStates: this.state.orderEditedPaidStates.merge({ [orderId]: false })
      })
    } else if (statusType === 'delivery') {
      this.setState({
        orderDeliveryStatuses: this.state.orderDeliveryStatuses.merge({ [orderId]: this.state.initialOrderDeliveryStatuses[orderId] }),
        orderEditedDeliveryStates: this.state.orderEditedDeliveryStates.merge({ [orderId]: false })
      })
    }
  }

  _onDateChange = (dateField, value) => {
    this.setState({ [dateField]: value })
  }

  _onSearch = () => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=time&startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}`)
  }

  _onUpload = (e, orderId) => {
    this.props.attemptUploadInvoice({ orderId, file: e.currentTarget.files[0] })
  }

  _onCreateCwOrder = (orderId) => {
    this.props.attemptCreateCwOrder({ orderId });
  }

  _onCreatePackPdf = (orderId, docHash) => {
    // เปิดแท็บว่างไว้ก่อนทันที (ยังอยู่ใน user gesture จะได้ไม่โดน popup blocker)
    const pdfWindow = window.open('', '_blank');
    // ยิง POST สร้างไฟล์ แล้วรอจน server ตอบว่าสำเร็จก่อน ค่อยเปิดไฟล์ PDF
    api.createPackPdf({ orderId })
      .then(() => {
        const url = `/services/docs/${orderId}-pack${docHash ? `-${docHash}` : ''}.pdf?ts=${new Date().getTime().toString(16)}`;
        if (pdfWindow) {
          pdfWindow.location = url;
        } else {
          window.open(url, '_blank');
        }
      })
      .catch(() => {
        if (pdfWindow) pdfWindow.close();
        window.alert('สร้างใบจัดสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
      });
  }

  _renderRow = ({ checkedOutAt, orderId, orderCode, invoicePath, deliveryName, deliveryContactNumber, pharmacyName, products = [], promoCode, promoDiscount, promoUnit, docHash }) => {
    const totalPrice = products.reduce((total, { amount, currentPrice }) =>
      total + (parseInt(amount, 10) || 0) * (parseFloat(currentPrice) || 0)
      , 0)
    return (
      <tbody key={orderId}>
        <tr>
          <td rowSpan={products.length + (promoCode ? 5 : 3)} className={classes.firstCol}>
            <div>{moment(checkedOutAt).format('DD-MM-YYYY')}</div>
            <div>{moment(checkedOutAt).format('HH:mm:ss')}</div>
            <div><strong>{orderId}</strong></div>
            {orderCode
              ? <div style={{ fontSize: 16 }}><span>({orderCode})</span></div>
              : <button disabled={this.props.cwOrderCreating} style={{ marginBottom: 10, cursor: 'pointer' }} onClick={() => this._onCreateCwOrder(orderId)}>สร้างบิลใน CW</button>}
            <a
              className={classes.button}
              onClick={() => this._onCreatePackPdf(orderId, docHash)}>
              <img role='presentation' src='/images/icon-print.png' />
              <span>ใบจัดสินค้า</span>
            </a>
            <a style={{
              cursor: 'pointer',
              display: this.state.createPackPdf ? 'block' : 'none',
              color: '#eb7c19'
            }}
              onClick={() => this._onCreatePackPdf(orderId, docHash)}>
              <span>สร้างใบจัดสินค้าใหม่</span>
            </a>
            <div className={classes.btnUpload} onClick={() => this.refs[`fileChooser${orderId}`].click()}>อัพโหลดใบส่งสินค้า</div>
            <input type='file' ref={`fileChooser${orderId}`} style={{ display: 'none' }} onChange={(e) => this._onUpload(e, orderId)} />
            {Boolean(invoicePath) && (
              <a target='_blank' href={invoicePath} className={classes.button}>
                <img role='presentation' src='/images/icon-print.png' />
                <span>ใบส่งสินค้า</span>
              </a>
            )}
          </td>
          <td rowSpan={products.length + (promoCode ? 5 : 3)}>
            <div style={{ marginBottom: 10 }}>{pharmacyName}</div>
            <div className='text-black'>{deliveryName}</div>
            <div>{deliveryContactNumber}</div>
          </td>
          <td className={classes.index}>ลำดับ</td>
          <td className={classes.productNo}>รหัสสินค้า</td>
          <td className={classes.productName}>ชื่อสินค้า</td>
          <td className={classes.amount}>จำนวน</td>
          <td className={classes.unit}>หน่วย</td>
          <td className={classes.price}>ราคา</td>
          <td className={classes.total}>ราคาสุทธิ</td>
          <td className={classes.status} rowSpan={products.length + (promoCode ? 5 : 3)}>
            <RadioButtonGroup radioClassName={classes.radioButtonGroup}
              disabled={!this.state.orderEditedPaidStates[orderId]}
              name={`${orderId}.paidStatus`}
              selectedValue={this.state.orderPaidStatuses[orderId]}
              onChange={(status) => this.setState({ orderPaidStatuses: this.state.orderPaidStatuses.merge({ [orderId]: status }) })}
              options={PAID_STATUS} />
            <div className={classes.buttonGroup}>
              <div className={classes.row}>
                <div className={classes.col} />
                <div className={classes.col}>
                  {this.state.orderEditedPaidStates[orderId] && (
                    <div onClick={() => this._onSaveStatus(orderId, 'paid')}>
                      <img className={classes.save} src='/images/icon-disk-orange.png' alt='icon-save' />
                      <span>บันทึก</span>
                    </div>
                  )}
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.col}>
                  {!this.state.orderEditedPaidStates[orderId] && (
                    <div onClick={() => this._onEditStatus(orderId, 'paid')}>
                      <img className={classes.edit} src='/images/icon-pencil-orange.png' alt='icon-edit' />
                      <span>แก้ไข</span>
                    </div>
                  )}
                </div>
                <div className={classes.col}>
                  {this.state.orderEditedPaidStates[orderId] && (
                    <div onClick={() => this._onCancelStatus(orderId, 'paid')}>
                      <img className={classes.delete} src='/images/icon-bin-orange.png' alt='icon-delete' />
                      <span>ยกเลิก</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </td>
          <td className={classes.status} rowSpan={products.length + (promoCode ? 5 : 3)}>
            <RadioButtonGroup radioClassName={classes.radioButtonGroup}
              disabled={!this.state.orderEditedDeliveryStates[orderId]}
              name={`${orderId}.deliveryStatus`}
              selectedValue={this.state.orderDeliveryStatuses[orderId]}
              onChange={(status) => this.setState({ orderDeliveryStatuses: this.state.orderDeliveryStatuses.merge({ [orderId]: status }) })}
              options={DELIVERY_STATUS} />
            <div className={classes.buttonGroup}>
              <div className={classes.row}>
                <div className={classes.col} />
                <div className={classes.col}>
                  {this.state.orderEditedDeliveryStates[orderId] && (
                    <div onClick={() => this._onSaveStatus(orderId, 'delivery')}>
                      <img className={classes.save} src='/images/icon-disk-orange.png' alt='icon-save' />
                      <span>บันทึก</span>
                    </div>
                  )}
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.col}>
                  {!this.state.orderEditedDeliveryStates[orderId] && (
                    <div onClick={() => this._onEditStatus(orderId, 'delivery')}>
                      <img className={classes.edit} src='/images/icon-pencil-orange.png' alt='icon-edit' />
                      <span>แก้ไข</span>
                    </div>
                  )}
                </div>
                <div className={classes.col}>
                  {this.state.orderEditedDeliveryStates[orderId] && (
                    <div onClick={() => this._onCancelStatus(orderId, 'delivery')}>
                      <img className={classes.delete} src='/images/icon-bin-orange.png' alt='icon-delete' />
                      <span>ยกเลิก</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </td>
        </tr>
        {products.map(({ productCode, unitId, productName, amount, unit, currentPrice }, index) =>
          (index < 2 || this.state[`${orderId}Visible`]) &&
          <tr className={classes.verticalCenter} key={`${orderId}.${productCode}-${unitId}`}>
            <td className='text-center'>{index + 1}</td>
            <td className='text-center'>{productCode}</td>
            <td>{productName}</td>
            <td className='text-center'>{amount}</td>
            <td className='text-center'>{unit}</td>
            <td className='text-center'>{formatMoney(currentPrice)}</td>
            <td className='text-center'>{formatMoney(amount * currentPrice)}</td>
          </tr>
        )}
        {products.length > 2 &&
          <tr className={classes.toggle}>
            <td className='text-center' colSpan='7' onClick={() => this.setState({ [`${orderId}Visible`]: !this.state[`${orderId}Visible`] })}>
              <img role='presentation' width='14' height='16'
                src={`/images/icon-arrow-${this.state[`${orderId}Visible`] ? 'up' : 'down'}.png`} />
            </td>
          </tr>
        }
        <tr className={classes.verticalCenter}>
          <td colSpan='6' style={{ textAlign: 'right' }}>ราคารวม</td>
          <td className='text-center'>{formatMoney(totalPrice)}</td>
        </tr>
        {promoCode && (
          <tr>
            <td colSpan='6' style={{ textAlign: 'right' }}>
              <span>ส่วนลด </span>
              <span className='color-blue'>{promoDiscount} {promoUnit === 'baht' ? 'บาท' : '%'}</span>
              <span> จากโค้ดส่วนลด </span>
              <span className='color-orange'>{promoCode}</span>
            </td>
            <td className='text-center'>-{formatMoney(promoUnit === 'baht' ? promoDiscount : (promoDiscount * totalPrice / 100))}</td>
          </tr>
        )}
        {promoCode && (
          <tr className={classes.verticalCenter}>
            <td colSpan='6' style={{ textAlign: 'right' }}>ราคารวมหลังหักส่วนลด</td>
            <td className='text-center'>{formatMoney(totalPrice - (!promoCode ? 0 : promoUnit === 'baht' ? promoDiscount : (promoDiscount * totalPrice / 100)))}</td>
          </tr>
        )}
      </tbody>
    )
  }

  render() {
    const { orders, location, pageCount } = this.props
    return (
      <section className={classes.orders}>
        <Heading>ค้นหา</Heading>
        <div className='text-center'>
          <RadioButtonGroup name='searchBy'
            selectedValue={query(this.props, 'searchBy') || 'status'}
            onChange={this._onSearchByChange}
            options={SEARCH_BY_OPTIONS} />
        </div>
        <div className='search-box'>
          {(query(this.props, 'searchBy') || 'status') === 'status' && (
            <RadioButtonGroup name='status'
              selectedValue={query(this.props, 'status') || 'all'}
              onChange={this._onStatusChange}
              options={[{ title: 'ทั้งหมด', value: 'all' }].concat(ORDER_STATUS_OPTIONS)} />
          )}
          {query(this.props, 'searchBy') === 'keyword' && (
            <Searchbox description='ค้นหารายการสั่งซื้อได้จาก Order No, ชื่อ, เบอร์โทร, ชื่อร้าน/บริษัท'
              keyword={query(this.props, 'keyword')}
              onSearch={(keyword) => this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=keyword&keyword=${keyword}`)} />
          )}
          {query(this.props, 'searchBy') === 'time' && (
            <div className='time-range-selector'>
              <span>ข้อมูลระหว่าง วันที่</span>
              <div className='date-picker-container'>
                <DatePicker ref='startDate' dateFormat='DD-MM-YYYY' selected={this.state.startDate} onChange={(date) => this._onDateChange('startDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <span style={{ marginLeft: '15px' }}>ถึง</span>
              <div className='date-picker-container'>
                <DatePicker ref='endDate' dateFormat='DD-MM-YYYY' selected={this.state.endDate} onChange={(date) => this._onDateChange('endDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <div className='btn-time-range-search' onClick={this._onSearch}>
                <img src='/images/icon-search-white.png' alt='icon-search-white' />
              </div>
            </div>
          )}
        </div>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        <table>
          <thead>
            <tr>
              <th>วันที่ / Order No.</th>
              <th>ข้อมูลลูกค้า</th>
              <th colSpan='7'>รายละเอียด</th>
              <th>สถานะการชำระเงิน</th>
              <th>สถานะการส่งสินค้า</th>
            </tr>
          </thead>
          {orders.map(this._renderRow)}
          {!orders.length && <tr><td className='text-center' colSpan='10'>ยังไม่มีรายการสั่งซื้อ</td></tr>}
        </table>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default AdminOrders



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminOrder/AdminOrders.js